export const isExternalUrl = (url: string): boolean => {
  if (!url) {
    return false
  }
  return url.indexOf('://') > 0 || url.indexOf('//') === 0
}

export const isInternalMotatDomain = (url: string): boolean => {
  if (!url) {
    return false
  }

  // Remove protocol and www if present
  const cleanUrl = url.replace(/^(https?:\/\/)?(www\.)?/, '')

  // List of internal MOTAT domains
  const internalDomains = [
    'motat.nz',
    'my.motat',
    'collection.motat.nz',
    'motat.shop',
  ]

  return internalDomains.some((domain) => cleanUrl.startsWith(domain))
}

export const getLinkTarget = (url: string): string => {
  // Internal relative paths (no protocol) always open in same tab
  if (!isExternalUrl(url)) return '_self'

  // Check if it's an internal MOTAT domain
  if (isInternalMotatDomain(url)) return '_self'

  // All other external URLs open in new tab
  return '_blank'
}

export const getValidUrl = (url: string): string => {
  if (!url) {
    return ''
  }

  if (
    url.startsWith('http') ||
    url.startsWith('mailto') ||
    url.startsWith('tel')
  ) {
    return url
  }

  // Special case for root URL
  if (url === '/') {
    return url
  }

  // Ensure the URL starts and ends with a slash if it doesn't already have one
  return (url.startsWith('/') ? '' : '/') + url + (url.endsWith('/') ? '' : '/')
}
